/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, March 18th 2022, 7:38:58 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

export const SetupStepper = ({ children, step }) => {
  const childrenArray = React.Children.toArray(children) as React.ReactElement[];

  const currentChild = childrenArray[step];

  const getStepperClass = (index: number) => {
    if (step < index) return "os-incompleted-step";
    if (step === index) return "os-active-step";
    if (step > index) return "os-completed-step";
    return "";
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <Stepper className="os-stepper-wrapper" activeStep={step}>
        {childrenArray.map((child, index) => (
          <Step className={getStepperClass(index)} key={index}>
            <StepLabel>{child.props.label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      {currentChild}
    </React.Fragment>
  );
};
